import { Routes, Route } from "react-router-dom";
import { SpedDevolutionList } from "./list";

export function SpedDevolutionRoutes() {
    return (
        <Routes>
            <Route path="/" element={<SpedDevolutionList />} />            
        </Routes>
    )
}